import { render, staticRenderFns } from "./ColorConfig.vue?vue&type=template&id=21851b32&scoped=true&"
import script from "./ColorConfig.vue?vue&type=script&lang=js&"
export * from "./ColorConfig.vue?vue&type=script&lang=js&"
import style0 from "./ColorConfig.vue?vue&type=style&index=0&id=21851b32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21851b32",
  null
  
)

export default component.exports